import { Field, ID, ObjectType } from 'type-graphql'
import { ChatMessage } from '../chat/Chat'

@ObjectType()
export class UserConversationList {
  @Field(() => ID)
  _id: string

  @Field(() => String)
  subject: string

  @Field(() => String)
  tenant: string

  @Field(() => Boolean)
  isUnread: boolean

  @Field(() => Date)
  timeStamp: Date

  @Field(() => [ChatMessage])
  chatMessages: ChatMessage[]
}
